import { IAlcanceDoVinculo, IClienteDaCarteira, IUsuarioDaOrganizacao, Lado } from "./gestao-de-usuarios.types";

export interface IRaiz {
  raiz: string;
  nome: string;
  empresas: IClienteDaCarteira[];
}

export const raizDoCnpj = (cnpj: string) => cnpj.replace(/\D/g, "").slice(0, 8);

const porNome = (a: IClienteDaCarteira, b: IClienteDaCarteira) => a.nome.localeCompare(b.nome, "pt-BR");
const ehMatriz = (e: IClienteDaCarteira) => e.cnpj.replace(/\D/g, "").slice(8, 12) === "0001";

export function agruparPorRaiz(carteira: IClienteDaCarteira[]): IRaiz[] {
  const grupos = new Map<string, IClienteDaCarteira[]>();
  for (const e of [...carteira].sort(porNome)) {
    const raiz = raizDoCnpj(e.cnpj);
    grupos.set(raiz, [...(grupos.get(raiz) ?? []), e]);
  }
  return [...grupos.entries()]
    .map(([raiz, empresas]) => ({ raiz, nome: (empresas.find(ehMatriz) ?? empresas[0]).nome, empresas }))
    .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
}

// why: botão = o que a rota aceita (podeConcederAlcance do backend): sessão de corretora com Gestão
// e toda a carteira, sobre outra pessoa. Sem a própria linha, fecha.
export function podeMudarAlcance(
  p: { lado: Lado | null; podeGerir: boolean; minhaLinha: IUsuarioDaOrganizacao | undefined },
  alvo: IUsuarioDaOrganizacao,
): boolean {
  return (
    p.lado === "CORRETORA" &&
    p.podeGerir &&
    p.minhaLinha?.alcance === "ORGANIZACAO" &&
    p.minhaLinha.organizationUserId !== alvo.organizationUserId
  );
}

// why: mudar o próprio Balanço a rota /eu/balanco aceita sempre; o de outra pessoa segue a regra de concessão.
export function podeMudarBalanco(
  p: { lado: Lado | null; podeGerir: boolean; minhaLinha: IUsuarioDaOrganizacao | undefined },
  alvo: IUsuarioDaOrganizacao,
  meuUserId: string | undefined,
): boolean {
  return (meuUserId !== undefined && alvo.userId === meuUserId) || podeMudarAlcance(p, alvo);
}

export function raizInteira(
  alvo: { incluidas: string[] },
  empresa: IClienteDaCarteira,
  carteira: IClienteDaCarteira[],
): boolean {
  const raiz = raizDoCnpj(empresa.cnpj);
  const outras = carteira.filter((e) => e.organizationId !== empresa.organizationId && raizDoCnpj(e.cnpj) === raiz);
  return outras.length > 0 && outras.every((e) => alvo.incluidas.includes(e.organizationId));
}

// why: o convite ainda não tem vínculo; monta o "atual" do ModalDeAlcance a partir do que ele guarda
// (decisão 1 do plano B3). Sem decisões gravadas: nada a marcar como pendente ou não incluído.
export function alcanceDoConvite(
  convite: { alcance: "ORGANIZACAO" | "SELECAO"; selecao: string[] },
  carteira: IClienteDaCarteira[],
  corretoraId: string,
): IAlcanceDoVinculo {
  return {
    alcance: convite.alcance,
    incluidas:
      convite.alcance === "SELECAO" ? convite.selecao.filter((id) => carteira.some((e) => e.organizationId === id)) : [],
    naoIncluidas: [],
    pendentes: [],
    carteira: carteira.map((e) => e.organizationId),
    corretoraId,
  };
}
